import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import contractsReducer from './slices/contractsSlice';
import dashboardReducer from './slices/dashboardSlice';
import templatesReducer from './slices/templatesSlice';
import usersReducer from './slices/usersSlice';
import notificationsReducer from './slices/notificationsSlice';
import settingsReducer from './slices/settingsSlice';
import languageReducer from './slices/languageSlice';
import fieldsManagerReducer from './slices/fieldsManagerSlice';
import rolesReducer from './slices/rolesSlice';
import departmentsReducer from './slices/departmentsSlice';
import companiesReducer from './slices/companiesSlice';
import groupsReducer from './slices/groupsSlice';
import contractTemplatesReducer from './slices/contractTemplatesSlice';
import tasksReducer from './slices/tasksSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    contracts: contractsReducer,
    dashboard: dashboardReducer,
    templates: templatesReducer,
    users: usersReducer,
    notifications: notificationsReducer,
    settings: settingsReducer,
    language: languageReducer,
    fieldsManager: fieldsManagerReducer,
    roles: rolesReducer,
    departments: departmentsReducer,
    companies: companiesReducer,
    groups: groupsReducer,
    contractTemplates: contractTemplatesReducer,
    tasks: tasksReducer,
  },
});

export default store;
